import { Building2, Clock3, ShieldCheck, UserRound } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { formatGodoDate } from "../../../lib/date";

interface DashboardSessionHeaderProps {
  organizationName: string;
  username: string;
  roleLabel: string;
}

export function DashboardSessionHeader({
  organizationName,
  username,
  roleLabel,
}: DashboardSessionHeaderProps) {
  const { t } = useTranslation();
  const [currentDateTime, setCurrentDateTime] = useState(() => formatGodoDate(new Date()));

  useEffect(() => {
    const timer = window.setInterval(() => {
      setCurrentDateTime(formatGodoDate(new Date()));
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <header className="flex flex-wrap items-center justify-between gap-2 rounded-xl border border-emerald-200/80 bg-white/85 px-3 py-2 shadow-sm backdrop-blur-sm">
      <div className="min-w-0">
        <p className="text-[10px] font-semibold uppercase tracking-wide text-emerald-700">
          {t("dashboard.executive_title")}
        </p>
        <h1 className="text-base font-bold leading-tight text-[#1b4332]">{organizationName}</h1>
      </div>

      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-[#2d6a4f]">
        <span className="inline-flex items-center gap-1">
          <UserRound className="h-3.5 w-3.5 shrink-0" aria-hidden />
          <span className="truncate">{username}</span>
        </span>
        <span className="inline-flex items-center gap-1">
          <ShieldCheck className="h-3.5 w-3.5 shrink-0" aria-hidden />
          <span>{roleLabel}</span>
        </span>
        <span className="inline-flex items-center gap-1" dir="ltr">
          <Clock3 className="h-3.5 w-3.5 shrink-0" aria-hidden />
          <span className="font-mono">{currentDateTime}</span>
        </span>
        <span className="inline-flex items-center gap-1">
          <Building2 className="h-3.5 w-3.5 shrink-0" aria-hidden />
          <span className="rounded bg-emerald-100 px-1.5 py-0.5 text-[10px] font-medium text-emerald-800">
            {t("labels.session_active")}
          </span>
        </span>
      </div>
    </header>
  );
}
